import { equalizeItems, resetItems } from '../equalizeHeights';

class TableMobileEqualizer {
    constructor() {
        window.addEventListener('resize', this.handleResize.bind(this));

        this.tableList = Array.from(document.querySelectorAll('.table.js-mobile-version'));

        this.handleResize();
    }
    handleResize() {
        window.innerWidth <= 768 ? this.set() : this.set(true);
    }
    set(reset) {
        this.tableList.map(table => {
            const tableChildren = Array.from(table.children);
            let head;
            let body;

            tableChildren.map(child => {
                if (child.nodeName === 'THEAD') head = child;
                if (child.nodeName === 'TBODY') body = child;
            });

            const thList = head.children[0].children;
            const trList = body.children;

            if (trList && thList) {
                const columnsCount = thList.length;

                for (let i = 0; i < columnsCount; i++) {
                    const head = thList[i];
                    const rows = Array.from(trList);
                    const cells = [];

                    cells.push(head);
                    rows.map(row => cells.push(row.children[i]));

                    reset ? resetItems(cells, table.classList.contains('has-short-cells') ? null : 40) : equalizeItems(cells);
                }
            }
        });
    }
}

new TableMobileEqualizer();
